import { render, staticRenderFns } from "./DropdownComponent.vue?vue&type=template&id=aff0593c&scoped=true&"
import script from "./DropdownComponent.vue?vue&type=script&lang=js&"
export * from "./DropdownComponent.vue?vue&type=script&lang=js&"
import style0 from "./DropdownComponent.vue?vue&type=style&index=0&id=aff0593c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff0593c",
  null
  
)

export default component.exports